export default "__VITE_ASSET__NNZPw0m5__"